import { useEffect, useState, type ReactElement } from 'react';
import { ActionPopup } from '@fz/ui-components-react';
import { WebSessionActionPopupContent } from '@features/passenger-details/components/WebSessionActionPopup/WebSessionActionPopupContent';
import { selectLoadingError, useAppStore } from '@store/app.store';
import './_web-session-action-popup.scss';
import { mapWebSessionActionPopupViewProps } from '@helper/web-session-popup-view-mapper';
import { useWebSessionActionPopup } from '@features/passenger-details/hooks';

export const WebSessionActionPopup = (): ReactElement => {
  const [isOpen, setIsOpen] = useState(false);
  const loadingError = useAppStore(selectLoadingError);
  const { handleClose, handleContinue, handleCancel } = useWebSessionActionPopup();
  const popupViewProps = mapWebSessionActionPopupViewProps(loadingError.cmsKey, {
    onClose: handleClose,
    onContinue: handleContinue,
    onCancel: handleCancel,
  });

  useEffect(() => {
    setIsOpen(loadingError.hasError);
  }, [loadingError.hasError]);

  return (
    <ActionPopup
      isOpen={isOpen}
      onClose={popupViewProps.onClose}
      title={popupViewProps.title}
      className={popupViewProps.popupClassName}
      showHeaderBg={popupViewProps.showHeaderBackground}
      showCloseButton={popupViewProps.showCloseButton}
      showRestrictedIcon={Boolean(!popupViewProps?.message)}
      closeOnOverlayClick={false}
      customContent={
        <WebSessionActionPopupContent
          heading={popupViewProps?.message || loadingError.errorMessage}
        />
      }
      actions={popupViewProps.actions}
      layout={popupViewProps.layout}
      align={popupViewProps.align}
      actionsAlign={popupViewProps.actionsAlign}
      groupButtons={popupViewProps.groupButtons}
      size={popupViewProps.size}
      titleClass={popupViewProps.titleClass}
    />
  );
};
